import { getInitialLensPack } from './lens-pack.js';

function calcGlassesPrice(glassesType, prices) {
    if (glassesType === 'frameAndMonofocal') {
        return prices.frameAndMonofocalPrice;
    }
    if (glassesType === 'frameAndMultifocal') {
        return prices.frameAndMultifocalPrice;
    }
    return prices.framePrice;
}
/**
 * Calculates the +/- price for a selected glasses type compared to the initial type.
 */ function calcGlassesPriceDifference(glassesType, initialGlassesType = 'frameAndMonofocal', prices) {
    const priceMapping = {
        frameOnly: prices.framePrice,
        frameAndMonofocal: prices.frameAndMonofocalPrice,
        frameAndMultifocal: prices.frameAndMultifocalPrice
    };
    return priceMapping[glassesType] - priceMapping[initialGlassesType];
}
function calcLensPackPrice(frameData, lensPackData, glassesType, lensPack, useIncludedLensPack = false) {
    const { brand , isKidsGlasses  } = frameData;
    let lensPackPrice = 0;
    if (glassesType === 'frameOnly') {
        return lensPackPrice;
    }
    const { monofocalLensPacks , multifocalLensPacks , includedLensPack  } = lensPackData;
    const activePackList = glassesType === 'frameAndMonofocal' ? monofocalLensPacks : multifocalLensPacks;
    const selectedPack = activePackList.find((pack)=>pack.pack.key === lensPack
    );
    if (!selectedPack) {
        return lensPackPrice;
    }
    if (!useIncludedLensPack) {
        var _priceInCents;
        return (_priceInCents = selectedPack.priceInCents) !== null && _priceInCents !== void 0 ? _priceInCents : 0;
    }
    if (includedLensPack && includedLensPack.pack.key === lensPack && glassesType === 'frameAndMonofocal') {
        // if the lensPack is already included, then set lensPackPrice to 0
        lensPackPrice = 0;
    } else if (glassesType === 'frameAndMonofocal' && lensPack === 'basic' && (brand.toLowerCase() === 'seen' || isKidsGlasses)) {
        // 'basic' is included on Seen and kids glasses --> when pack is included, set lensPackPrice to 0
        lensPackPrice = 0;
    } else if (glassesType === 'frameAndMonofocal' && lensPack === 'basic' && brand.toLowerCase() !== 'seen' && !isKidsGlasses) {
        // 'bronze' is also included on other brands --> when pack is included, set lensPackPrice to 0
        lensPackPrice = 0;
    } else if (glassesType === 'frameAndMultifocal' && (brand.toLowerCase() === 'seen' || isKidsGlasses)) {
        // 'basic' pack price is also included on Seen and 'kids' glasses when MULTIfocal
        // The price of 'basic' needs to be subtracted from every lenspack to make calculations be correct
        const basicMultiPack = getInitialLensPack(multifocalLensPacks, 'basic');
        var _priceInCents1;
        const basicMultiPackPrice = (_priceInCents1 = basicMultiPack.priceInCents) !== null && _priceInCents1 !== void 0 ? _priceInCents1 : 0;
        var _priceInCents2;
        lensPackPrice = ((_priceInCents2 = selectedPack.priceInCents) !== null && _priceInCents2 !== void 0 ? _priceInCents2 : 0) - basicMultiPackPrice;
    } else if (glassesType === 'frameAndMultifocal' && !isKidsGlasses) {
        // 'bronze' pack price is included on non-Seen and non-'kids' glasses when MULTIfocal
        // The price of 'bronze' needs to be subtracted from every lenspack to make calculations be correct
        const basicMultiPack = getInitialLensPack(multifocalLensPacks, 'basic');
        var _priceInCents3;
        const basicMultiPackPrice = (_priceInCents3 = basicMultiPack.priceInCents) !== null && _priceInCents3 !== void 0 ? _priceInCents3 : 0;
        var _priceInCents4;
        lensPackPrice = ((_priceInCents4 = selectedPack.priceInCents) !== null && _priceInCents4 !== void 0 ? _priceInCents4 : 0) - basicMultiPackPrice;
    } else {
        var _priceInCents5;
        lensPackPrice = (_priceInCents5 = selectedPack.priceInCents) !== null && _priceInCents5 !== void 0 ? _priceInCents5 : 0;
    }
    return lensPackPrice;
}
function calcSelectedExtrasPrice(extrasData, selectedExtras) {
    const price = 0;
    if (selectedExtras) {
        return extrasData.filter(({ value  })=>selectedExtras.indexOf(value) >= 0
        ).reduce((sum, item)=>sum + item.price || 0
        , 0);
    }
    return price;
}

export { calcGlassesPrice, calcGlassesPriceDifference, calcLensPackPrice, calcSelectedExtrasPrice };
//# sourceMappingURL=calculation.js.map
